import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FormDataService } from './form-data.service';
import { environment } from 'src/environments/environment';

//const API_URL = 'https://cep-uat-gfedeucmgvcte3c2.uksouth-01.azurewebsites.net/api/EasyClaim/GetConfig/';

@Injectable({
  providedIn: 'root'
})
export class ConfigService implements Resolve<any> {

  config: any;
  claimid: any;
  treatmentType: any;
  caseresult: any;
  imageLabelMap: Map<string, string>;
  baseUrl = environment.apiEndpoint;
  API_URL = this.baseUrl + 'GetConfig/';
  carParts = ['back', 'front', 'interior', 'left', 'odometer', 'right'];

  constructor(
    private http: HttpClient,
    private formDataService: FormDataService) {
    this.initImageLabelMap();
  }

  resolveBlock(
    route: ActivatedRouteSnapshot
  ) {
    this.claimid = route.queryParamMap.get('claimid');
    this.caseresult = route.queryParamMap.get('caseresult');
    this.http.get(this.API_URL + this.claimid).toPromise()
      .then(x => {
        console.log(x);
        console.log('then');
      });
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    this.claimid = route.queryParamMap.get('claimid');
    this.treatmentType = route.queryParamMap.get('treatmenttype');
    this.caseresult = route.queryParamMap.get('caseresult');
    this.caseresult = route.queryParamMap.get('caseresult');
    this.http.get(this.API_URL + this.claimid).subscribe(res => {
      this.config = res;
      console.log(this.config);
      this.doConfig(this.claimid, this.treatmentType, this.config);
    });
    return this.config;
  }



  doConfig(claimId, treatmentType, config) {
    this.formDataService.setClaimId(claimId);
    this.formDataService.setTreatmentType(treatmentType);
    this.formDataService.setAnalyticsId(config.Data.analytics_id);
    this.formDataService.setEasyClaimType(config.Data.EasyClaimType);
    console.log(config.Data.vehiclePartLogoVMs);
    this.formDataService.setPerspectiveSides(config.Data.images.perspective_sides);
    this.formDataService.setPhotos(config.Data.images.required_sides.map(i => {
      return {
        i,
        // imageData: i == "" ? "" : 'assets/s2/img/' + this.getCarPartImageName(i) + '.jpg',
        imageData: i == "" ? "" : this.getCarPartLogo(config.Data.vehiclePartLogoVMs, i.split(':')[0].toString()),
        //imageDataLogo: i == "" ? "" : this.getCarPartLogo(config.Data.vehiclePartLogoVMs, i.split(':')[0].toString()),
        valid: false,
        filename: '',
        //label: this.imageLabelMap.get(i.toLowerCase())
        label: i == "" ? "" : i.split(':')[1].toString().toUpperCase(),
        sideName: i.split(':')[0].toString(),
        sideNameLabel: i.split(':')[1].toString(),
        showRemoveBtn: false
        //imageSideData: i == "" ? "" : this.getCarPartLogo(config.Data.vehiclePartLogoVMs, i.split(':')[0].toString())
      };
    }));
    this.formDataService.setAdditionalPhotos(config.Data.images.other_sides.map(i => {
      return {
        i,
        // imageData: 'assets/s2/img/additionalimage.jpg',
        //imageData: 'assets/s2/img/' + i + '.jpg',
        imageData: i == "" ? "" : this.getCarPartLogo(config.Data.vehiclePartLogoVMs, i.split(':')[0].toString()),
        //imageDataLogo: i == "" ? "" : this.getCarPartLogo(config.Data.vehiclePartLogoVMs, i.split(':')[0].toString()),
        valid: false,
        filename: '',
        //label: this.imageLabelMap.get(i.toLowerCase())
        label: i == "" ? "" : i.split(':')[1].toString().toUpperCase(),
        sideName: i.split(':')[0].toString(),
        sideNameLabel: i.split(':')[1].toString(),
        showRemoveBtn: false
        //imageSideData: i == "" ? "" : this.getCarPartLogo(config.Data.vehiclePartLogoVMs, i.split(':')[0].toString())
      };
    }));
    this.formDataService.setQuestions(config.Data.questions.map(q => {
      q.Answer = '';
      return q;
    }));
  }



  initImageLabelMap() {
    this.imageLabelMap = new Map();
    this.imageLabelMap.set('front', 'FRONT');
    this.imageLabelMap.set('left', 'LEFT');
    this.imageLabelMap.set('right', 'RIGHT');
    this.imageLabelMap.set('back', 'BACK');
    this.imageLabelMap.set('interior', 'INTERIOR');
    this.imageLabelMap.set('odometer', 'ODOMETER');
    this.imageLabelMap.set('rearleft', 'REARLEFT');
    this.imageLabelMap.set('rearright', 'REARRIGHT');
    this.imageLabelMap.set('rear', 'REAR');
    this.imageLabelMap.set('fromleftdiagonal', 'FROMLEFTDIAGONAL');
    this.imageLabelMap.set('frontrightdiagonal', 'FRONTRIGHTDIAGONAL');
    this.imageLabelMap.set('rearleftdiagonal', 'REARLEFTDIAGONAL');
    this.imageLabelMap.set('rearrightdiagonal', 'REARRIGHTDIAGONAL');
    this.imageLabelMap.set('vin', 'VIN');
  }

  resolveMock(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.config = {
      IsError: false,
      Messages: [
        {
          Code: '2000',
          Key: '',
          Message: 'Success'
        }
      ],
      Data: {
        Investigation_type: 'Manual',
        email_template_logo_name: 'controlexpert.png',
        questions: [
          {
            question_text: 'When did the incident happen?',
            question_set: 1,
            screen_number: 2,
            answer_type: 'date',
            question_type: 'date of incident',
            qn_number: 'qn-1',
            is_required: 'yes'
          },
          {
            question_text: 'What is the mileage of your vehicle?',
            question_set: 1,
            screen_number: 2,
            answer_type: 'number',
            question_type: 'odometer',
            qn_number: 'qn-2',
            is_required: 'yes'
          },
          {
            question_text: 'Did any of your airbags have been deployed?',
            question_set: 1,
            screen_number: 2,
            answer_type: 'yes_no',
            question_type: 'airbag',
            qn_number: 'qn-3',
            is_required: 'yes'
          },
          {
            question_text: 'Decision feedback?',
            question_set: 2,
            screen_number: 1,
            answer_type: 'number',
            question_type: '',
            qn_number: 'qn-4',
            is_required: 'yes'
          },
          {
            question_text: 'Final decision?',
            question_set: 3,
            screen_number: 1,
            answer_type: 'yes_no',
            question_type: '',
            qn_number: 'qn-5',
            is_required: 'yes'
          }
        ],
        images: {
          required_sides: [
            'frontdiagonalleft',
            'frontdiagonalright',
            'backdiagonalleft',
            'backdiagonalright',
            'additionalimage'
          ],
          number_of_mandatory_images: 5,
          screen_number: 1,
          maximum_number_of_images: 15
        },
        email_templates: [
          {
            email_no: 'Email-1',
            message_line_1: 'Hi',
            message_line_2: 'Please click this link to start the claim process.',
            message_line_3: 'Thank you',
            message_line_4: 'Control Expert',
            message_line_5: null,
            message_line_6: null
          },
          {
            email_no: 'Email-2',
            message_line_1: 'Details Received',
            message_line_2: 'Thank you for submitting damage details along with photos.',
            message_line_3: 'We will contact you within 24hrs once our experts have estimated the repair to your vehicle.',
            message_line_4: 'Thank you,',
            message_line_5: 'Control Expert',
            message_line_6: null
          },
          {
            email_no: 'Email-3',
            message_line_1: 'Evaluation Result',
            message_line_2: 'The prediction of your accident have been done by our experts. These are the result values:',
            message_line_3: 'Decision support prediction is',
            message_line_4: 'Please click this link to start the second phase of claim process.',
            message_line_5: 'Thank you,',
            message_line_6: 'Control Expert'
          },
          {
            email_no: 'Email-4',
            message_line_1: 'Feedback Received',
            message_line_2: 'Thank you for your answer.',
            message_line_3: 'Please click this link to start the third phase of claim process.',
            message_line_4: 'Thank you,',
            message_line_5: 'Control Expert',
            message_line_6: null
          },
          {
            email_no: 'Email-5',
            message_line_1: 'Final Decision Received',
            message_line_2: 'Thank you for your answer.',
            message_line_3: 'Thank you,',
            message_line_4: 'Control Expert',
            message_line_5: null,
            message_line_6: null
          }
        ]
      }
    }
      ;
    return this.config;
  }

  setConfig(p1) {
    this.config = p1;
  }

  getCarPartImageName(carPartName) {
    var splitCarPartLabel = carPartName.split(';');
    var carPart = this.carParts.filter(x => x == splitCarPartLabel[0]);
    if (carPart != null && carPart.length > 0) {
      return carPartName;
    }
    else {
      return "additionalimage";
    }
  }

  getCarPartLogo(carPartLogos, carPartName) {
    carPartName = carPartName.toLowerCase();
    var carPartLogo = carPartLogos.filter(x => x.VehicleSide == carPartName);
    if (carPartLogo != null && carPartLogo.length > 0) {
      return carPartLogo[0].SideLogoBase64String;
    }
    else {
      carPartLogo = carPartLogos.filter(x => x.VehicleSide == "default");
      return carPartLogo.length > 0 ? carPartLogo[0].SideLogoBase64String : null;
    }
  }
}
